import Head from 'next/head'
import { AboutUs } from '@twlvxtwlv/ui/src/components/pages/homepage/about-us/about-us'
import type { GetServerSideProps, GetServerSidePropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { HomepagePageComponent } from '@twlvxtwlv/ui/src/components/pages/homepage/shared/homepage-component'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

const AboutUsPage = () => {
  const { t } = useTranslation()

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])
  return (
    <>
      <Head>
        <title>{t('meta-title-about-us')}</title>
        <meta name="description" content={t('meta-description-default') ?? undefined} />
      </Head>
      {isMounted ? (
        <HomepagePageComponent>
          <AboutUs />
        </HomepagePageComponent>
      ) : null}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  locale = 'de',
}: GetServerSidePropsContext) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, [
        'common',
        'navigation',
        'footer',
        'front-page',
        'user-management',
      ])),
    },
  }
}
export default AboutUsPage
